import { formatBaht } from '@xver/utils/number';
import { Modal } from '@mantine/core';
import { IconCircleCheckFilled, IconCurrencyBaht } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@xver/components/Atoms';

import { MONEY_GREEN, MONEY_GREEN_DEEP } from '../methodTheme';

interface PromptPaySuccessModalProps {
    opened: boolean;
    amount: number;
    onClose: () => void;
}

export default function PromptPaySuccessModal({
    opened,
    amount,
    onClose,
}: PromptPaySuccessModalProps) {
    const { t } = useTranslation('topup');

    const formattedAmount = formatBaht(amount, 0, 2);

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={t('modal.success.title')}
            centered
            size="sm"
            overlayProps={{ backgroundOpacity: 0.7, blur: 4 }}
        >
            <div className="flex flex-col items-center gap-5 pb-2">
                <div
                    className="relative inline-flex items-center justify-center size-20 rounded-full"
                    style={{
                        background: 'rgba(34,197,94,0.15)',
                        boxShadow: '0 0 0 6px rgba(34,197,94,0.08)',
                    }}
                >
                    <IconCircleCheckFilled size={56} style={{ color: MONEY_GREEN }} />
                </div>

                <div className="flex flex-col items-center gap-1">
                    <span className="text-xs uppercase tracking-widest text-fg/68">
                        {t('hero.title')}
                    </span>
                    <div className="flex items-end gap-1">
                        <span className="text-4xl font-bold tabular-nums text-fg">
                            {formattedAmount}
                        </span>
                        <IconCurrencyBaht size={26} stroke={2.5} className="text-fg/80 mb-0.5" />
                    </div>
                </div>

                <p className="text-sm text-fg/70 text-center">
                    {t('modal.success.body', { amount: formattedAmount })}
                </p>

                <Button
                    onClick={onClose}
                    width="100%"
                    bgColor={MONEY_GREEN}
                    borderColor={MONEY_GREEN}
                    textColor={MONEY_GREEN_DEEP}
                    fontWeight={700}
                >
                    {t('modal.success.confirm')}
                </Button>
            </div>
        </Modal>
    );
}
